import { AppAreaConfig } from '@/funnels/@types'
import maleActivityCalisthenics from './activity-male-calisthenics'

const appAreaConfig: AppAreaConfig = {
	appArea: 'military-male',
	landing: {
		ids: ['loader-military-m', 'age-military-m'],
		route: {
			path: '/military-m',
			name: 'military-male-funnel',
		},
	},
	funnel: {
		id: 'ob-military-male',
		route: {
			path: '/military-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'military-male-onboarding',
		},
		slug: 'military-male',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: maleActivityCalisthenics,
				page: 'how-much-walking',
			},
		},
	},
}

export default appAreaConfig
